import { autoRegisterFeature } from '@store/features/factory';

import { transcriptionFeature } from './store/feature';

autoRegisterFeature(transcriptionFeature);

export * from './store';
export * from './types';
